import { PropsWithChildren } from 'react';
import { Outlet } from 'react-router-dom';

import {
  AppLayout as CoreLayout,
  Props as CoreLayoutProps,
} from '@sorare/core/src/components/navigation/AppLayout';

export const AppLayout = ({
  children,
  ...otherProps
}: PropsWithChildren<CoreLayoutProps>) => {
  return <CoreLayout {...otherProps}>{children || <Outlet />}</CoreLayout>;
};
